import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton } from "../../components";
import MesAffaireTable from "./component/MesAffaireTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";
import { useEffect, useState } from "react";
import { listAsyncOffreByBoss } from "../../store/features/offreSlice";

function MesAffaires() {
  const dispatch = useDispatch();
  const [isPersonal, setIsPersonal] = useState(false);

  // const offres = useSelector((state: RootState) => Object.values(state.offre));
  const user = useSelector((state: RootState) => state.auth.user);

  const [data, setData] = useState([]) as any;

  // console.log("####",user)

  const togglePersonal = (value: boolean) => {
    setIsPersonal(value);
  };

  const callback = (item: any) => {
    setData(item);
  };

  const getData = () => {
    dispatch(listAsyncOffreByBoss(user?.idUtilisateur, callback) as any);
  };

  console.log("data",data);

  useEffect(() => {
    getData();
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("mes_affaires")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomButton
            title={i18n.t("mes_dossiers_personnels")}
            titleStyle={{
              marginLeft: 1,
              color: isPersonal ? "#ffffff" : "#3D423F",
            }}
            rootStyle={{
              backgroundColor: isPersonal ? "#00080C" : "#E7FFE7",
              height: 45,
              width: 250,
            }}
            onClick={() => togglePersonal(true)}
          />
          <CustomButton
            title={i18n.t("dossier_group")}
            titleStyle={{ marginLeft: 1, color: !isPersonal ? "#ffffff" : "#3D423F", }}
            rootStyle={{
              backgroundColor: isPersonal ? "#E7FFE7" : "#00080C",
              height: 45,
              width: 250,
            }}
            onClick={() => togglePersonal(false)}
          />
        </Stack>
      </Stack>
      <MesAffaireTable data={data} />
    </Box>
  );
}

export default MesAffaires;
